import useStyles from "./styles";

const MAX_NOTIFCATION_COUNT = 9;

const component = ( { notificationCount } ) => {

	const classes = useStyles ( { notificationCount } );

	const Counter = () => {
		if ( notificationCount > 9 ) {
			return (
				<p>
					{MAX_NOTIFCATION_COUNT}
					+
				</p>
			);
		} else
			return notificationCount;
	};

	return (
		<div className = { classes.notificationIconContainer }>

			{ notificationCount ? (
				<div
					className = { classes.notificationCounter }
				>
					<Counter />
				</div>
			) : null}

		</div>

	);
};

export default component;
